// extracted by mini-css-extract-plugin
export var extraInfo = "style-module--extra-info--725a2";
export var form = "style-module--form--be255";
export var giftBlock = "style-module--gift-block--382a4";
export var img = "style-module--img--34815";
export var info = "style-module--info--8a283";
export var inner = "style-module--inner--1018a";
export var policy = "style-module--policy--d0637";
export var price = "style-module--price--715dd";
export var reg = "style-module--reg--786e6";
export var screen1 = "style-module--screen1--6305f";
export var sub = "style-module--sub--1270d";
export var type = "style-module--type--440d1";
export var wrap = "style-module--wrap--a7e88";